<script setup lang="ts">
import { useWindowFocus } from "@vueuse/core";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import UiDialog from "@/shared/ui/UiDialog.vue";
import { useAppStore } from "@/store/app";

const store = useAppStore();
const route = useRoute();
const focused = useWindowFocus();

const storageClientID = ref("");
const isDialogVisible = ref(false);

const getLocalStorageClientID = () => {
  const user = localStorage.getItem("user");
  if (user) {
    try {
      return JSON.parse(user).clientID;
    } catch {
      return;
    }
  }
};

const onLoginClick = () => {
  window.localStorage.setItem("afterLoginCallback", route.fullPath);
  window.location.href = window.location.href;
};

watch(
  () => [focused.value, store.isLoading, route.fullPath],
  () => {
    if (!focused.value || store.isLoading) {
      isDialogVisible.value = false;
      return;
    }

    storageClientID.value = getLocalStorageClientID() || "";
    if (!storageClientID.value) {
      isDialogVisible.value = true;
    } else {
      isDialogVisible.value = false;
    }
  },
  { immediate: true, deep: true },
);
</script>
<template>
  <UiDialog
    v-model:dialogVisible="isDialogVisible"
    title="You are not logged in"
    subtitle="Please log in to continue"
    persistent
    :closeIcon="false"
    icon="$TriangleExclamation"
    iconColor="warning"
  >
    <template #actions>
      <EccaBtn @click="onLoginClick">Login</EccaBtn>
    </template>
  </UiDialog>
</template>
